// extracted by mini-css-extract-plugin
module.exports =  {"workspace":"workspace__F8AZL"};